import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const document = {
  namespaced: true,
  state: {
    driverDocuments: [],
    taxiDocuments: [],
  },
  getters,
  mutations,
  actions
}
